let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bOYlI")).then(() => parcelRequire('37xrd'));